import { GuestCategoryRequests } from '@/services/guest-category.requests'
const guestCategoriesService = new GuestCategoryRequests()

const state = {
  list: []
}

const getters = {}

const actions = {
  list ({ state }) {
    return new Promise((resolve, reject) => {
      guestCategoriesService.list().then(async (guestCategories) => {
        state.list = guestCategories
        resolve(guestCategories)
      }).catch((error) => {
        reject(error)
      })
    })
  }
}

const mutations = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
